module.exports = __webpack_public_path__ + "static/media/helveticaNeue.ef86ae5e.fnt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/helveticaNeue.fnt
// module id = 369
// module chunks = 0